import { parse } from "svgson";
import { getShapeUrl } from "./get-shape-url.js";
const getParsedShape = async (shapeSrc, getUrlOverride) => {
  try {
    const shapeUrl = getShapeUrl(shapeSrc, getUrlOverride);
    const svgJson = await fetch(shapeUrl).then((res) => res.text()).then((text) => parse(text));
    return svgJson;
  } catch (error) {
    console.error("[ShapeService] Failed to fetch shapes:", error);
    throw error;
  }
};
export {
  getParsedShape
};
//# sourceMappingURL=get-parsed-shape.js.map
